import React, { useState, useEffect } from "react";
import { List, ListItem, TextField, makeStyles } from "@material-ui/core";
import { useConfigs } from "../config-provider";
var useStyles = makeStyles(function (theme) {
  return {
    filterInput: {
      margin: 10,
      "& .MuiOutlinedInput-input": {
        padding: "10px 7px"
      }
    },
    noOptions: {
      color: theme.palette.text.secondary,
      padding: "14px 16px"
    }
  };
});

var ProList = function ProList(_a) {
  var options = _a.options,
      isSearch = _a.isSearch,
      selected = _a.selected,
      renderOption = _a.renderOption,
      onChange = _a.onChange;
  var locale = useConfigs().locale;
  var classes = useStyles();

  var _b = useState([]),
      option = _b[0],
      setOption = _b[1];

  useEffect(function () {
    setOption(options);
  }, [options]);

  var handleInput = function handleInput(e) {
    var value = e.target.value;

    if (value) {
      var arr_1 = [];
      options.forEach(function (item) {
        if (item.label.toLowerCase().includes(value.toLowerCase())) {
          arr_1.push(item);
        }
      });
      setOption(arr_1);
    } else {
      setOption(options);
    }
  };

  return React.createElement("div", {
    style: {
      maxHeight: isSearch ? 400 : 300
    }
  }, isSearch && React.createElement(TextField, {
    variant: "outlined",
    className: classes.filterInput,
    onChange: handleInput
  }), option.length === 0 ? React.createElement("div", {
    className: classes.noOptions
  }, locale.common.noOptions) : React.createElement(List, {
    style: {
      maxHeight: 300
    }
  }, option.map(function (item, idx) {
    if (renderOption) return renderOption(item, idx, selected, onChange);
    return React.createElement(ListItem, {
      selected: selected === item.value,
      key: idx,
      onClick: function onClick() {
        return onChange(item);
      },
      button: true
    }, item.label);
  })));
};

export default ProList;